function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import Auth from '../../functions/authenticate';
import { ssoEligible, redirectToCentralLogin } from '../../auth/sso';
export default class extends React.Component {
  constructor(props) {
    super(props);
    // On *.plunk.io we might already hold an auth.plunk.io session (e.g.
    // just redirected here from central login). Start in a `checking`
    // state so the sign-in FORM never flashes before the silent SSO
    // attach resolves. Localhost dev has no broker cookie → skip straight
    // to the form.
    _defineProperty(this, "onEmailChange", event => {
      this.setState({
        email: event.target.value,
        error: false,
        errorMessage: ''
      });
    });
    _defineProperty(this, "onPasswordChange", event => {
      this.setState({
        password: event.target.value,
        error: false,
        errorMessage: ''
      });
    });
    _defineProperty(this, "onSubmit", async event => {
      if (event && event.preventDefault) event.preventDefault();
      if (this.state.submitting) return;
      this.setState({
        submitting: true,
        error: false,
        errorMessage: ''
      });
      const email = (this.state.email || '').toLowerCase();
      const password = this.state.password;
      try {
        await Auth.signIn(email, password);
        location.href = Auth.returnUrl();
      } catch (err) {
        // Cognito error codes: NotAuthorizedException (bad creds),
        // UserNotConfirmedException, PasswordResetRequiredException,
        // UserNotFoundException, NetworkError.
        const code = err && err.code || '';
        let msg = 'Invalid email or password. Please try again.';
        if (code === 'UserNotConfirmedException') {
          msg = 'Account not confirmed. Check your email for a verification link.';
        } else if (code === 'PasswordResetRequiredException') {
          msg = 'Password reset required. Contact support.';
        } else if (code === 'NetworkError' || err && /network/i.test(err.message || '')) {
          msg = 'Network error. Check your connection and try again.';
        }
        this.setState({
          error: true,
          errorMessage: msg,
          submitting: false
        });
      }
    });
    this.state = {
      error: false,
      errorMessage: '',
      email: '',
      password: '',
      submitting: false,
      checking: ssoEligible()
    };
  }

  // Silent SSO attach: if the browser already holds an auth.plunk.io
  // session (signed in via another Plunk app), adopt it and skip the form.
  async componentDidMount() {
    if (!this.state.checking) return;
    try {
      const attached = await Auth.trySsoAttach();
      if (attached) {
        location.href = Auth.returnUrl();
        return;
      } // keep the loader up through the reload
    } catch (ex) {/* fall through */}
    // On *.plunk.io there's no in-app login — go to central login (keep the
    // loader up through the redirect). The form only shows on localhost.
    if (ssoEligible()) {
      redirectToCentralLogin(window.location.origin);
      return;
    }
    this.setState({
      checking: false
    });
  }
  render() {
    const {
      error,
      errorMessage,
      submitting,
      email,
      password,
      checking
    } = this.state;

    // While the silent SSO attach is in flight, render only the branded
    // shell (no form) so it doesn't flicker in before we know whether the
    // user already has a session.
    if (checking) {
      return /*#__PURE__*/React.createElement("div", {
        className: "plk-signin-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "plk-signin-form-panel"
      }, /*#__PURE__*/React.createElement("div", {
        className: "plk-signin-form-wrap"
      }, /*#__PURE__*/React.createElement("div", {
        className: "plk-signin-brand"
      }, /*#__PURE__*/React.createElement("div", {
        className: "plk-signin-logo"
      }, "PLUNK")), /*#__PURE__*/React.createElement("div", {
        className: "plk-signin-welcome"
      }, /*#__PURE__*/React.createElement("p", null, "Signing you in\u2026")))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-form-panel"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-form-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-brand"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-logo"
    }, "PLUNK")), /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-welcome"
    }, /*#__PURE__*/React.createElement("h1", null, "Welcome back"), /*#__PURE__*/React.createElement("p", null, "Sign in to access your dashboard, insights, and AI analysis.")), /*#__PURE__*/React.createElement("form", {
      className: "plk-signin-form",
      onSubmit: this.onSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "signin-email"
    }, "Email"), /*#__PURE__*/React.createElement(Input, {
      id: "signin-email",
      type: "email",
      value: email,
      onChange: this.onEmailChange,
      autoComplete: "email",
      autoFocus: true
    })), /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-field"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "signin-password"
    }, "Password"), /*#__PURE__*/React.createElement(Input, {
      id: "signin-password",
      type: "password",
      value: password,
      onChange: this.onPasswordChange,
      autoComplete: "current-password"
    })), /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-row"
    }, /*#__PURE__*/React.createElement("a", {
      className: "plk-signin-forgot",
      href: "#forgot"
    }, "Forgot your password?")), error && /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-error"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "error_outline"), /*#__PURE__*/React.createElement("span", null, errorMessage || 'Invalid email or password. Please try again.')), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      size: "large",
      disabled: submitting || !email || !password,
      className: "plk-signin-submit",
      onClick: this.onSubmit
    }, submitting ? 'Signing in…' : 'Sign In', !submitting && /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle',
        marginLeft: '6px'
      }
    }, "arrow_forward"))), /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-footer"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://plunk.io/privacy-policy.html",
      target: "_blank",
      rel: "noreferrer"
    }, "Privacy"), /*#__PURE__*/React.createElement("span", {
      className: "plk-signin-dot"
    }, "\xB7"), /*#__PURE__*/React.createElement("a", {
      href: "https://plunk.io/terms.html",
      target: "_blank",
      rel: "noreferrer"
    }, "Terms"), /*#__PURE__*/React.createElement("span", {
      className: "plk-signin-dot"
    }, "\xB7"), /*#__PURE__*/React.createElement("span", null, "\xA9 ", new Date().getFullYear(), " Plunk")))), /*#__PURE__*/React.createElement("aside", {
      className: "plk-signin-hero"
    }, /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-hero-content"
    }, /*#__PURE__*/React.createElement("h2", null, "Analytics that move with your business."), /*#__PURE__*/React.createElement("p", null, "Track every visitor, forecast product performance, and run AI analysis across your entire operation."), /*#__PURE__*/React.createElement("ul", {
      className: "plk-signin-features"
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "insights"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Real-time activity"), /*#__PURE__*/React.createElement("small", null, "Impressions, conversions, and sessions as they happen."))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "online_prediction"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Product forecasting"), /*#__PURE__*/React.createElement("small", null, "Predict demand and similarity for every SKU."))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "auto_awesome"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "AI-driven insights"), /*#__PURE__*/React.createElement("small", null, "Generate executive summaries from your data."))))), /*#__PURE__*/React.createElement("div", {
      className: "plk-signin-hero-glow",
      "aria-hidden": "true"
    })));
  }
}